<template>
  <div>
    <p class="p-title">
      Para solicitar autorización del padre para acceder al expediente del
      estudiante, utilizar la SAEE-20 contenida en el Manual de Procedimientos.
    </p>

    <div class="bg-secondary-13 p-3 rounded">
      <validation-observer ref="form">
        <div class="row">
          <div class="col-auto">
            <label class="data-title mb-2">Tipo de Documento:</label>
            <p>{{ data.documentTypeName }}</p>
          </div>
          <div class="col-1">
            <action-button
              v-if="!hasDocument"
              class="mt-md-4"
              variant="success"
              i="fas fa-file-download"
              @click="downloadTemplate()"
            />
          </div>
          <div class="col-12 col-md">
            <label class="data-title mb-1">Archivo:</label>
            <custom-file-input
              ref="documentFile"
              id="documentFile"
              v-model="model"
              accept=".pdf"
              display-style="normal"
              label-position="left"
              :on-download="onDownloadFile"
              :name="data.documentName"
              :attachment-id="data.documentId"
              @input="onFileChange"
              :disabled="readOnly"
            />
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import CustomFileInput from "CustomFileInput";
import ActionButton from "ActionButton";

export default {
  name: "VisualInpairmentsEnterRecordParentsAuthorization",
  components: {
    CustomFileInput,
    ActionButton
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {}
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: null
    };
  },
  computed: {
    hasDocument() {
      return this.data?.documentId || this.model || this.readOnly;
    }
  },
  mounted() {},
  methods: {
    onFileChange(value) {
      if (value) {
        this.$emit("file-change", value);
      } else {
        this.data.documentId = null;
        this.$emit("file-remove", this.data);
      }
    },
    onDownloadFile() {
      this.$emit("file-download", this.data);
    },
    downloadTemplate() {
      this.$emit("file-download", {
        documentId: "9FAC8589-96D4-4BFD-9C29-C461637DE916" //SAEE-20 Consentimiento para compartir información.pdf
      });
    },
    async validate() {
      const hasValue =
        this.data.documentId && this.$refs.documentFile.status !== "deleted";
      return hasValue || (await this.$refs.form.validate());
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_colors.scss";

.p-title {
  color: map-get($colors, "black");
  font: normal normal bold 15px/19px Lato;
}
</style>
